import { createFileRoute } from '@tanstack/react-router';
import { WorkDetailPage } from '@/components/app/WorkDetailPage';

export const Route = createFileRoute('/app/works/$workId')({
  component: WorkDetailRoute,
});

function WorkDetailRoute() {
  const { workId } = Route.useParams();
  return <WorkDetailPage workId={workId} />;
}
